// extracted by mini-css-extract-plugin
export var clay = "clay-module--clay--54b42";
export var clayEx = "clay-module--clayEx--7d038";
export var clayPrimary = "clay-module--clayPrimary--10f4d";
export var clayRev = "clay-module--clayRev--a40a8";
export var clayShadowDown = "clay-module--clayShadowDown--479e8";
export var clayShadowRightDown = "clay-module--clayShadowRightDown--01d1d";